import { render, staticRenderFns } from "./rqb.vue?vue&type=template&id=9154dcf8&scoped=true&"
import script from "./rqb.vue?vue&type=script&lang=js&"
export * from "./rqb.vue?vue&type=script&lang=js&"
import style0 from "./rqb.vue?vue&type=style&index=0&id=9154dcf8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9154dcf8",
  null
  
)

export default component.exports